export const MESES_ABREV = [
  "ENE",
  "FEB",
  "MAR",
  "ABR",
  "MAY",
  "JUN",
  "JUL",
  "AGO",
  "SEP",
  "OCT",
  "NOV",
  "DIC",
];

// Tolera separadores `-` y `/` en la cadena de fecha (la BD almacena
// fechaCreacion como "YYYY/MM/DD" mientras que la fecha del builder PDF
// usa "YYYY-MM-DD"). Devuelve null si la cadena no es interpretable.
function splitDateParts(fechaStr) {
  if (!fechaStr) return null;
  const parts = String(fechaStr)
    .split(/[-/]/)
    .map((p) => parseInt(p, 10));
  if (parts.length < 3 || parts.some(Number.isNaN)) return null;
  return parts;
}

/** Formato corto uppercase para portada: "27 ABR 2026". */
export function formatFechaPortada(fechaStr) {
  const parts = splitDateParts(fechaStr);
  const d = parts ? new Date(parts[0], parts[1] - 1, parts[2]) : new Date();
  return `${d.getDate()} ${MESES_ABREV[d.getMonth()]} ${d.getFullYear()}`;
}

/** Año "YYYY" desde una fecha ISO o slash-separada; año actual si falta. */
export function obtenerAnio(fechaStr) {
  const parts = splitDateParts(fechaStr);
  return String(parts ? parts[0] : new Date().getFullYear());
}

/**
 * Divide un título en dos líneas para el render bicolor (linea1 blanca,
 * linea2 naranja). Respeta "\n" explícito; sin él parte por la mitad de
 * palabras. Si solo hay una palabra, linea2 queda vacía.
 */
export function splitTituloBicolor(titulo) {
  if (!titulo) return { linea1: "", linea2: "" };
  if (titulo.includes("\n")) {
    const [l1, ...rest] = titulo.split("\n");
    return { linea1: l1.trim(), linea2: rest.join(" ").trim() };
  }
  const palabras = titulo.trim().split(/\s+/);
  if (palabras.length <= 1) return { linea1: titulo.trim(), linea2: "" };
  const corte = Math.ceil(palabras.length / 2);
  return {
    linea1: palabras.slice(0, corte).join(" "),
    linea2: palabras.slice(corte).join(" "),
  };
}
